<template>
  <div class="spinner-page" v-if="isNewsDetailsLoading">
    <q-spinner class="spinner" color="primary" size="3em" />
  </div>
  <div v-else class="news-details-page">
    <ShareNewsDetails />

    <div class="column pagetop">
      <div class="row heading-scheme justify-between">
        <div class="row">
          <h2 class="title"><span v-html="title"></span></h2>
          <i
            v-if="isVind"
            class="las la-2x la-share action-icon q-ml-md"
            @click="shareNewsItem()"
          >
            <q-tooltip>
              Delen
            </q-tooltip></i
          >
        </div>
        <div class="topinfo-item">
          <span class="topinfo-item-heading">Datum</span>
          <span class="topinfo-item-value">{{ formatDate(date) }}</span>
        </div>
      </div>
    </div>

    <div class="row page-lower">
      <div class="column">
        <div id="introduction"></div>

        <div class="large-item">
          <div class="introduction">
            <div v-html="introduction"></div>
          </div>
          <div class="introduction">
            <div v-html="body"></div>
          </div>
          <div id="body"></div>
        </div>

        <q-separator
          class="full-width-separator"
          v-if="schemes != null && schemes.length > 0"
        />
        <div class="large-item" v-if="schemes != null && schemes.length > 0">
          <span class="box-title">
            Gerelateerde regelingen
          </span>
          <div class="scheme-news">
            <div v-for="scheme in schemes" :key="scheme.id">
              <!--               {{ formatDate(scheme.createdDate) }} &nbsp;
 -->
              <router-link
                class="news-link"
                style="text-decoration: underline; color:#0a108f"
                :to="{ name: 'GrantDetails', params: { grantId: scheme.id } }"
                target="_blank"
              >
                {{ scheme.name }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="circle-container">
      <div id="pagetop" class="top-scroll" v-if="scY > 300">
        <i class="las la-2x la-angle-up up-icon" @click="toTop">
          <q-tooltip self="center left" :offset="[10, 10]"
            >Naar boven</q-tooltip
          >
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, ref } from 'vue';
import NewsService from '../services/news.service';
import { useRoute, useRouter } from 'vue-router';
import store from '../store/index';
import moment from 'moment';
import ShareNewsDetails from '../components/share-components/ShareNewsDetails.vue';
export default {
  components: {
    ShareNewsDetails,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const title = computed({
      get: () => store.state.news.selectedTitle,
    });

    const status = computed({
      get: () => store.state.news.selectedNewsStatus,
    });

    const body = computed({
      get: () => store.state.news.selectedBody,
    });
    const introduction = computed({
      get: () => store.state.news.selectedIntroduction,
    });
    const scope = computed({
      get: () => store.state.selectedNewsScopeTgas,
    });
    const date = computed({
      get: () =>
        store.state.news.selectedNewsDate != null
          ? moment(store.state.news.selectedNewsDate).format('YYYY-MM-DD')
          : null,
    });
    const organisations = computed({
      get: () => store.state.news.newsOrganisations,
    });
    const schemes = computed({
      get: () => store.state.news.selectedNewsSchemes,
    });
    const tags = computed({
      get: () => store.state.news.selectedNewsTags,
    });

    onMounted(async () => {
      window.scrollTo(0, 0);

      const id = route.params.newsId;
      window.addEventListener('scroll', handleScroll);
      
      var statisticType = store.state.user.hasComeFromNewsletter ? 'NewsletterClick' : 'NewsClick';

      await NewsService.getNewsById(id, statisticType);
    });

    const orgColumns = [
      {
        name: 'Organisation name',
        label: 'Organisation name',
        field: 'name',
        sortable: true,
        align: 'left',
      },
    ];

    const schemeColumns = [
      {
        name: 'Scheme name',
        label: 'Scheme name',
        field: 'name',
        sortable: true,
        align: 'left',
      },
    ];

    const scTimer = ref(0);
    const scY = ref(0);
    const handleScroll = () => {
      if (scTimer.value) return;
      scTimer.value = setTimeout(() => {
        scY.value = window.scrollY;
        clearTimeout(scTimer.value);
        scTimer.value = 0;
      }, 100);
    };

    const toTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    const formatDate = (stringDate) => {
      const date = new Date(stringDate);
      return moment(date).format('DD-MM-YYYY');
    };

    const newsItem = computed({
      get: () => store.state.news.selectedNewsItem,
    });

    const isNewsDetailsLoading = computed({
      get: () => store.state.news.isNewsDetailsLoading,
    });

    const selectedNewsItem = computed({
      get: () => store.state.news.selectedNewsItem,
    });

    const shareNewsItem = () => {
      store.commit('news/enableShareNews', selectedNewsItem);
    };
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40
    });

    return {
      isVind,
      isNewsDetailsLoading,
      newsItem,
      formatDate,
      router,
      handleScroll,
      toTop,
      scTimer,
      scY,
      organisations,
      schemes,
      tags,
      title,
      orgColumns,
      schemeColumns,
      body,
      scope,
      status,
      introduction,
      date,
      shareNewsItem,
    };
  },
};
</script>
